import React from "react";
import "./index.css";
import { Button, ModalFooter } from "reactstrap";

const Renderassessmentmodal = (props) => {
  return (
    <React.Fragment>
      <div className="modal-inner-content">
        <h1>{props.modalConfirmation}</h1>
        <p>{props.modalText}</p>
      </div>
      <ModalFooter>
        <Button className='reviewButton' onClick={props.handleReviewAssessment} style={{width:"fit-content"}}>{props.button1}</Button>
        <Button onClick={props.handleModalSubmit}>{props.button2}</Button>
      </ModalFooter>
    </React.Fragment>
  );
};

export default Renderassessmentmodal;



// WEBPACK FOOTER //
// ./src/new/Components/Self-assessment/begin-questionnaire/submit-assessment-modal/index.jsx